/**
 * Module dependencies.
 */

import { fetchGraphql } from 'utils/fetch-graphql';
import { normalizeSingleObject } from 'utils/normalizers';
import { pickSocialNetworks } from 'utils/social-networks';

/**
 * Query.
 */

const QUERY = `
    query {
      portfolioCategory {
        id
        translations {
          languages_code {
            code
          }
          title
          description
        }
        images {
          directus_files_id {
            width
            height
            title
            type
            filename_download
            filename_disk
            predominantColor
          }
        }
      }
      Company {
        facebook
        instagram
        twitter
        pinterest
        linkedin
        youtube
        address
        email
        phonePT
        phoneEN
        phoneFR
        latitude
        longitude
        translations {
          languages_code {
            code
          }
          schedule
        }
      }
    }
  `;

/**
 * Export `portfolioStaticProps`.
 */

export function portfolioStaticProps() {
  try {
    return fetchGraphql(QUERY).then((data) => {
      const result: any = {};

      result.portfolioCategory = normalizeSingleObject(data.portfolioCategory);
      result.company = normalizeSingleObject(data.Company);
      result.socialNetworks = pickSocialNetworks(data.Company);

      for (const item of result.portfolioCategory) {
        item.images = item.images.map((image) => ({
          ...image.directus_files_id,
        }));
      }

      return result;
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    throw error;
  }
}
